import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "../Pages/About/About";
import Forgot_Password from "../Pages/Auth/Forgot_Password";
import New_password from "../Pages/Auth/New_password";
import OTP from "../Pages/Auth/OTP";
import Sign_in from "../Pages/Auth/Sign_in";
import Sign_up from "../Pages/Auth/Sign_up";
import Sign_up_seller from "../Pages/Auth/Sign_up_seller";
import Checkout from "../Pages/Checkout/Checkout";
import Contact from "../Pages/Contact/Contact";
import Faq from "../Pages/Faq/Faq";
import Home from "../Pages/Home/Home";
import Advertise from "../Pages/Policies-page/Advertise";
import Privacypolicy from "../Pages/Policies-page/Privacy-policy";
import Terms from "../Pages/Policies-page/Terms";
import Seller_add_product from "../Pages/Seller-profile/Seller_add_product";
import Seller_banner_ad from "../Pages/Seller-profile/Seller_banner_ad";
import Seller_customer from "../Pages/Seller-profile/Seller_customer";
import Seller_dashboard from "../Pages/Seller-profile/Seller_dashboard";
import Seller_edit_info from "../Pages/Seller-profile/Seller_edit_info";
import Seller_info from "../Pages/Seller-profile/Seller_info";
import Seller_Inventory from "../Pages/Seller-profile/Seller_Inventory";
import Seller_orders from "../Pages/Seller-profile/Seller_orders";
import Seller_order_detail from "../Pages/Seller-profile/Seller_order_detail";
import Seller_refund_detail from "../Pages/Seller-profile/Seller_refund_detail";
import Seller_Refund_Orders from "../Pages/Seller-profile/Seller_Refund_Orders";
import Seller_Refund_Requests from "../Pages/Seller-profile/Seller_Refund_Requests";
import Seller_Reviews from "../Pages/Seller-profile/Seller_Reviews";
import Product_cart from "../Pages/Shop/Product_cart";
import Product_page from "../Pages/Shop/Product_page";
import Seller_store from "../Pages/Shop/Seller_store";
import Shop from "../Pages/Shop/Shop";
import Thank_you from "../Pages/Shop/Thank_you";
import Banner_ad from "../Pages/Subscription/Banner_ad";
import Banner_ads_form from "../Pages/Subscription/Banner_ads_form";
import Subscription_payment from "../Pages/Subscription/Subscription_payment";
import Subscription_Type from "../Pages/Subscription/Subscription_Type";
import MyAddresses from "../Pages/User_profile/MyAddresses";
import Myorder from "../Pages/User_profile/Myorder";
import MyorderDetail from "../Pages/User_profile/MyorderDetail";
import MyProfile from "../Pages/User_profile/MyProfile";
import MyWishlist from "../Pages/User_profile/MyWishlist";
import Payment from "../Pages/User_profile/Payment";
import Refund_Order from "../Pages/User_profile/Refund_Order";
import Return_detail from "../Pages/User_profile/Return_detail";
import Return_Requests from "../Pages/User_profile/Return_Requests";
import Security from "../Pages/User_profile/Security";
import Share from "../Pages/User_profile/Share";
import View_Banner_Ad from "../Pages/User_profile/View_Banner_Ad";
import Seller_order_detail2 from "../Pages/Seller-profile/seller-order-detail2";
import Seller_product_inventory_detail from "../Pages/Seller-profile/Seller_product_inventory_detail";
import Seller_account from "../Pages/Seller-profile/Seller_account";
import Seller_accept_refund from "../Pages/Seller-profile/Seller_accept_refund";
import Seller_reject_refund from "../Pages/Seller-profile/Seller_reject_refund";
import EditBanner from "../Pages/Subscription/EditBanner";
import Levels from "../Pages/levels/Levels";

const PublicRoutes = () => {
	return (
		<>
			<Router>
				<Routes>
					<Route path="/" element={<Home />} />
					<Route path="/about" element={<About />} />
					<Route path="/contact" element={<Contact />} />
					<Route path="/shop" element={<Shop />} />
					<Route path="/product" element={<Product_page />} />
					<Route path="/policy" element={<Privacypolicy />} />
					<Route path="/Terms" element={<Terms />} />
					<Route path="/Advertise" element={<Advertise />} />
					<Route path="/faqs" element={<Faq />} />
					<Route path="/sign-in" element={<Sign_in />} />
					<Route path="/sign-up" element={<Sign_up />} />
					<Route path="/sign-up-seller" element={<Sign_up_seller />} />
					<Route path="/Forgot_Password" element={<Forgot_Password />} />
					<Route path="/OTP" element={<OTP />} />
					<Route path="/New-password" element={<New_password />} />
					<Route path="/Subscription_Type" element={<Subscription_Type />} />
					<Route
						path="/Subscription_payment"
						element={<Subscription_payment />}
					/>
					<Route path="/banner-ad" element={<Banner_ad />} />
					<Route path="/banner-ad-form" element={<Banner_ads_form />} />
					<Route path="/edit-ad-form" element={<EditBanner />} />
					<Route path="/Seller-store" element={<Seller_store />} />
					<Route path="/Product-cart" element={<Product_cart />} />
					<Route path="/checkout" element={<Checkout />} />
					<Route path="/Thank_you" element={<Thank_you />} />
					{/* User Profile starts here */}
					<Route path="/MyProfile" element={<MyProfile />} />
					<Route path="/MyAddresses" element={<MyAddresses />} />
					<Route path="/Payment" element={<Payment />} />
					<Route path="/Security" element={<Security />} />
					<Route path="/return-request" element={<Return_Requests />} />
					<Route path="/Myorder" element={<Myorder />} />
					<Route path="/MyWishlist" element={<MyWishlist />} />
					<Route path="/Myorder-detail" element={<MyorderDetail />} />
					<Route path="/refund-order" element={<Refund_Order />} />
					<Route path="/view-banner-ads" element={<View_Banner_Ad />} />
					<Route path="/Return_detail" element={<Return_detail />} />
					<Route path="/share" element={<Share />} />
					<Route path="/levels" element={<Levels />} />
					{/* User Profile ends here */}
					{/* Seller dashboard starts here */}

					<Route path="/seller-dashboard" element={<Seller_dashboard />} />
					<Route path="/seller-customer" element={<Seller_customer />} />
					<Route
						path="/seller-order-details"
						element={<Seller_order_detail />}
					/>
					<Route path="/seller-Inventory" element={<Seller_Inventory />} />
					<Route path="/seller-add-product" element={<Seller_add_product />} />
					<Route
						path="/seller-refund-order"
						element={<Seller_Refund_Orders />}
					/>
					<Route
						path="/seller-refund-details"
						element={<Seller_refund_detail />}
					/>
					<Route
						path="/seller-refund-request"
						element={<Seller_Refund_Requests />}
					/>
					<Route path="/seller-banner-ads" element={<Seller_banner_ad />} />
					<Route path="/seller-order" element={<Seller_orders />} />
					<Route path="/seller-reviews" element={<Seller_Reviews />} />
					<Route path="/seller-info" element={<Seller_info />} />
					<Route path="/seller-edit-info" element={<Seller_edit_info />} />
					<Route path="/seller-detail2" element={<Seller_order_detail2 />} />
					<Route
						path="/seller-product-inventory"
						element={<Seller_product_inventory_detail />}
					/>
					<Route path="/seller-account" element={<Seller_account />} />
					<Route
						path="/seller-accept-refund"
						element={<Seller_accept_refund />}
					/>
					<Route
						path="/seller-reject-refund"
						element={<Seller_reject_refund />}
					/>
					{/* Seller dashboard ends here */}
				</Routes>
			</Router>
		</>
	);
};

export default PublicRoutes;
